//设置一个固定的key值
const KEY = 'Authorization';
const TokenType = 'TokenType';
const SiteKey = 'SiteType';
const NavKey = 'NavType';
const SiteOneKey = 'SiteOneType';
const ModelKey = 'ModelType';
const SearchKey = 'SearchType';
//暴露三个方法

//设置token
export function setToken(token) {
  window.localStorage.setItem(KEY, token);
}

//获取token
export function getToken() {
  return window.localStorage.getItem(KEY);
}

//获取tokenType
export function getTokenType() {
  return window.localStorage.getItem(TokenType);
}

//删除token
export function removeToken() {
  //根据key,删除指定的值
  window.localStorage.removeItem(KEY);
}
//设置站点
export function setSite(token) {
  window.localStorage.setItem(SiteKey, token);
}

//获取站点
export function getSite() {
  return window.localStorage.getItem(SiteKey);
}

//设置站点名称
export function setSiteOne(token) {
  window.localStorage.setItem(SiteOneKey, token);
}

//获取站点名称
export function getSiteOne() {
  return window.localStorage.getItem(SiteOneKey);
}

//设置导航
export function setNav(token) {
  window.localStorage.setItem(NavKey, token);
}

//获取导航
export function getNav() {
  return window.localStorage.getItem(NavKey);
}

//设置模型
export function setModel(token) {
  window.localStorage.setItem(ModelKey, token);
}

//获取模型
export function getModel() {
  return window.localStorage.getItem(ModelKey);
}

/**图片域名 */
export function getImgDomain() {
  return sessionStorage.getItem('imgDomain');
}

export function setImgDomain(data) {
  return sessionStorage.setItem('imgDomain', JSON.stringify(data));
}
/**搜索内容 */
export function getSearchValue() {
  return sessionStorage.getItem('SearchKey');
}

export function setSearchValue(data) {
  return sessionStorage.setItem('SearchKey', JSON.stringify(data));
}
